<template>
    <div>
        <el-select
            v-if="mode == 'edit'"
            :modelValue="currentValue"
            filterable
            :multiple="multiple"
            :placeholder="placeholder"
            class="wp-10"
            @change="update"
        >
            <slot name="option">
                <el-option
                    v-for="item in options"
                    :key="item[idColumn]"
                    :label="item[labelColumn]"
                    :value="parseInt(item[idColumn])"
                >
                </el-option>
            </slot>
        </el-select>
        <p v-else>
            <person-list :list="selectedItems" size="small" :relatedData="relatedData" />
        </p>
    </div>
</template>

<script>
import PersonList from 'vcomponents/utilities/PersonList.vue';

export default {
    components: {
        'person-list': PersonList,
    },
    props: {
        mode: {
            type: String,
        },
        modelValue: {
            type: [Array, Number, Boolean],
            required: false,
            default: () => [],
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        options: {
            type: Array,
            required: true,
            default: () => [],
        },
        labelColumn: {
            type: String,
            required: false,
            default: 'label',
        },
        idColumn: {
            type: String,
            required: false,
            default: 'value',
        },
        relatedData: {
            type: [Object, Boolean],
            required: false,
            default: false,
        },
        multiple: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    emits: ['update:modelValue'],
    computed: {
        currentValue() {
            if (!this.multiple) {
                return this.modelValue;
            }

            const values = [];
            if (this.modelValue && this.modelValue.length > 0) {
                this.modelValue.map((value) => {
                    const valueExist = this.options.find(
                        (item) => parseInt(item[this.idColumn]) === parseInt(value),
                    );
                    valueExist ? values.push(parseInt(value)) : false;
                });
            }

            return values;
        },
        selectedItems() {
            if (!this.multiple) {
                return this.options.filter((option) => this.modelValue === parseInt(option.id));
            }

            return this.options.filter((option) => this.modelValue.includes(parseInt(option.id)));
        },
    },
    methods: {
        update(newValue) {
            this.$emit('update:modelValue', newValue);
        },
    },
};
</script>
